module.exports = __webpack_public_path__ + "static/media/partner-logo17.4b9adfb0.png";